<template>
  <svg
    :class="customStyle"
    viewBox="0 0 64 64"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 5.5873V58.4127C16 61.4985 18.4624 64 21.5 64H58.5C61.5376 64 64 61.4985 64 58.4127V14.7025C64 13.21 63.4122 11.7796 62.3677 10.7301L53.2957 1.61483C52.266 0.58026 50.8762 0 49.428 0H21.5C18.4624 0 16 2.50152 16 5.5873ZM19.5 58.4127V5.5873C19.5 4.4652 20.3954 3.55556 21.5 3.55556H48.75V15.746C48.75 17.85 50.4289 19.5556 52.5 19.5556H60.5V58.4127C60.5 59.5348 59.6046 60.4444 58.5 60.4444H21.5C20.3954 60.4444 19.5 59.5348 19.5 58.4127ZM60.5 16V14.7025C60.5 14.1598 60.2863 13.6396 59.9064 13.258L52.25 5.56509V15.746C52.25 15.8863 52.3619 16 52.5 16H60.5Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41 26.25C41 25.2835 41.7835 24.5 42.75 24.5H54.25C55.2165 24.5 56 25.2835 56 26.25C56 27.2165 55.2165 28 54.25 28H42.75C41.7835 28 41 27.2165 41 26.25Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41 34.25C41 33.2835 41.7835 32.5 42.75 32.5H54.25C55.2165 32.5 56 33.2835 56 34.25C56 35.2165 55.2165 36 54.25 36H42.75C41.7835 36 41 35.2165 41 34.25Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41 42.25C41 41.2835 41.7835 40.5 42.75 40.5H54.25C55.2165 40.5 56 41.2835 56 42.25C56 43.2165 55.2165 44 54.25 44H42.75C41.7835 44 41 43.2165 41 42.25Z"
      fill="white"
    />
    <path
      d="M0 18.5C0 16.8431 1.34315 15.5 3 15.5H33C34.6569 15.5 36 16.8431 36 18.5V48.5C36 50.1569 34.6569 51.5 33 51.5H3C1.34315 51.5 0 50.1569 0 48.5V18.5Z"
      fill="white"
    />
    <path
      d="M10 43.543L15.6191 33.084L10.5195 23.5H14.4023L17.6973 29.9395L20.9238 23.5H24.7656L19.666 33.2344L25.2852 43.543H21.2793L17.6289 36.6113L13.9785 43.543H10Z"
      fill="#198661"
    />
  </svg>
</template>

<script>
export default {
  name: 'CsvLarge',
  props: {
    customStyle: {
      type: String,
      default: 'h-64 w-64',
    },
  },
}
</script>
